import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/_auth/dashboard/_layout/jobs')({
  component: () => <Outlet />,
})
